import React from "react"
import { FormContainer, Worksheet, LabeledInput, CheckboxYesNo } from "uikit"
import { Footer } from "./Footer"
import { Grid } from "semantic-ui-react"

import ConnectedAccountBar from "../../ConnectedAccountBar"
import HumanTimeSince from "components/HumanTimeSince"

const CreditCardForm = ({
  data: {
    fields: { balance, interest_rate, is_noncarried, monthly_payment },
    isModified,
    onSubmit,
    isPending,
    hasError,
    error
  },
  submitLabel = "Done",
  submitHeader = "",
  onDelete,
  isNew,
  lastUpdatedAt,
  account
}) => (
  <Grid>
    {account.connection_id ? (
      <Grid.Row style={{ borderBottom: "1px solid #ccc" }}>
        <Grid.Column>
          <ConnectedAccountBar {...account} />
        </Grid.Column>
      </Grid.Row>
    ) : null}
    <Grid.Row>
      <Grid.Column>
        <Worksheet error={error} style={{ borderTop: "1px solid #ccc" }}>
          <Worksheet.Body>
            <Worksheet.Row
              label="How much do you currently owe?"
              description={
                account.connection_id
                  ? "Automatically updated through the account connection"
                  : null
              }
              paddedField
            >
              <Worksheet.Field error={balance.error}>
                <LabeledInput
                  {...balance}
                  label=""
                  iconText="$"
                  iconPosition="left"
                  disabled={!!account.connection_id}
                  placeholder="0"
                  data-testid="balance"
                />
                {lastUpdatedAt}
              </Worksheet.Field>
            </Worksheet.Row>

            <Worksheet.Row
              label="Do you typically carry a balance?"
              paddedField
            >
              <Worksheet.Field>
                <CheckboxYesNo
                  fluid
                  checked={
                    is_noncarried.checked === undefined
                      ? is_noncarried.checked
                      : !is_noncarried.checked
                  }
                  onChange={(e, { value }) => {
                    is_noncarried.onChange(e, { value: !value })
                    monthly_payment.onChange(e, { value: "" })
                    interest_rate.onChange(e, { value: "" })
                  }}
                  name="is_noncarriedToggle"
                  data-testid="is_noncarried"
                />
              </Worksheet.Field>
              {is_noncarried.value === "false" ? (
                <Worksheet.Row
                  label="What is the interest rate (APR)?"
                  paddedField
                >
                  <Worksheet.Field error={interest_rate.error}>
                    <LabeledInput
                      {...interest_rate}
                      label=""
                      iconText="%"
                      placeholder="0"
                      data-testid="interest_rate"
                    />
                  </Worksheet.Field>
                </Worksheet.Row>
              ) : null}
              {is_noncarried.value === "false" ? (
                <Worksheet.Row
                  paddedField
                  label="Do you pay more than the minimum?"
                >
                  <Worksheet.Field>
                    <CheckboxYesNo
                      fluid
                      checked={monthly_payment.value !== ""}
                      toggle={() => {
                        if (monthly_payment.value !== "") {
                          monthly_payment.onChange(null, { value: "" })
                        } else {
                          monthly_payment.onChange(null, { value: 0 })
                        }
                      }}
                      name="paymorethanminimumToggle"
                      data-testid="moreThanMinimumPayment"
                    />
                  </Worksheet.Field>
                </Worksheet.Row>
              ) : null}
              {monthly_payment.value !== "" ? (
                <Worksheet.Row
                  paddedField
                  label="What do you typically pay each month?"
                >
                  <Worksheet.Field error={monthly_payment.error}>
                    <LabeledInput
                      {...monthly_payment}
                      label=""
                      iconText="$"
                      iconPosition="left"
                      placeholder="0"
                      data-testid="monthly_payment"
                    />
                  </Worksheet.Field>
                </Worksheet.Row>
              ) : null}
            </Worksheet.Row>
          </Worksheet.Body>
          <Footer
            isNew={isNew}
            submitLabel={submitLabel}
            onSubmit={onSubmit}
            onDelete={onDelete}
            isModified={isModified}
            deleteLabel={
              account.connection_id ? "Ignore Account" : "Delete Account"
            }
            hasConnectionId={account.connection_id ? true : false}
            error={error}
          />
        </Worksheet>{" "}
      </Grid.Column>
    </Grid.Row>
  </Grid>
)
const CreditCardFormContainer = FormContainer(
  {
    balance: {
      type: "unit",
      required: true,
      negative: true
    },
    interest_rate: {
      type: "decimal",
      minValue: 0,
      maxValue: 100,
      required: false
    },
    is_noncarried: {
      type: "boolean",
      required: false,
      defaultValue: "true"
    },
    monthly_payment: {
      type: "unit",
      required: false
    }
  },
  ({ fields: { is_noncarried, interest_rate, monthly_payment } }, ...form) => {
    if (is_noncarried.checked === false && interest_rate.value === "") {
      return {
        fields: {
          interest_rate: "This field is required."
        }
      }
    }
  }
)(CreditCardForm)

const CreditCard = ({ household, account, ...formProps }) => {
  const isNew = account === null
  const values = isNew ? {} : account
  const lastUpdatedAt = !isNew ? (
    <p
      style={{
        fontSize: "0.8em",
        textAlign: "right",
        fontWeight: "normal"
      }}
    >
      Updated <HumanTimeSince time={values.balance_updated_at} /> ago
    </p>
  ) : null
  return (
    <CreditCardFormContainer
      {...formProps}
      values={values}
      lastUpdatedAt={lastUpdatedAt}
      account={values}
    />
  )
}
export default CreditCard
